import React from 'react';
import '../login.css';
import ClickMe from 'material-ui/svg-icons/navigation/chevron-right';
import CircularProgress from 'material-ui/CircularProgress';
import ProviderCard from '../Components/ProviderCard';
import { ListItem} from 'material-ui/List';
import { Provider } from 'react-redux';
import { cdnPath } from '../constants/config';


class ProviderList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            view: 'list',
            fetching: false,
            provider: {},
            cost: 0
        };
    }

    selectProvider = (providerId, cost, distance, isDx) => {
        //hashHistory.push(`/shop/details/${facilityId}/view/${cost}/${distance}`);
        this.props.selectProvider(providerId, cost, isDx);
    }
   
    render() {

        var dasResults = this.props.providers.map((provider, index) => 
             <div className={provider.ItemClass + " trueno"} key={index}>
           
         <ListItem 
                innerDivStyle={{padding:"0 5px 7px 7px", marginBottom: 7}}
                primaryText={<div style={{marginTop: '10px'}}><span style={{fontSize:14}}>{provider.Name}</span><br /><span style={{color:'#666666', fontSize:12}} >{provider.Address}{provider.Distance && (" | Distance: "+Math.round(provider.Distance*10)/10)+" Miles"}</span></div>}
                 rightIcon={<ClickMe />}
                style={{border:'solid 1px #dddddd', backgroundColor:'#fff', fontFamily: 'TruenoLight'}}
                    onClick={() => this.selectProvider(provider.ProviderID, Math.round(provider.Price), Math.round(provider.Distance*10)/10, provider.IsDirectContract)}
                secondaryText={ 
                     <div style={{height:'auto', padding: '10px 0 0 10px'}}>
                         <table style={{width:'auto'}}>
                             <tr>
                                {(provider.Subtext != null) && (
                                    <td style={{paddingRight:5}}>
                                        <span>{provider.Subtext}</span>
                                    </td>
                                )}
                                <td>
                                    <h4>${ Math.round(provider.Price)  } </h4>
                                    {(provider.Price > 0) && (provider.Subtext == null) && (
                                        <span>Estimate</span>
                                    )}
                                </td>
                                <td>
                                    {(provider.IsDirectContract > 0) && (provider.NetworkKey) && (
                                        <img src={`https://${cdnPath}/networkimages/` + provider.NetworkKey + "-sr.png"}  style={{height:25, paddingLeft:10}} />    
                                    )}
                                </td>
                            </tr>
                        </table>
                    </div>
                }
              >
              </ListItem>
            </div>
        );
        
        return (
            <div>
                {(this.state.view === 'list') && (
                    <div>
                        { dasResults }
                    </div>
                )}

                {(this.state.view === 'provider') && (
                    <div>
                        {(this.state.fetching) && (
                            <div className="loader" >
                                <CircularProgress />
                            </div>
                        )}

                        {(!this.state.fetching) && (
                            <div>
                                <ProviderCard provider={this.state.provider} cost={this.state.cost} requireDocAndFacility={this.props.requireDocAndFacility} />
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
};

export default ProviderList;


// WEBPACK FOOTER //
// ./src/Components/ProviderList.js